import { render, staticRenderFns } from "./SystemGuideComponent.vue?vue&type=template&id=3059f0c5&"
import script from "./SystemGuideComponent.vue?vue&type=script&lang=js&"
export * from "./SystemGuideComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports